import axios from "axios";
import { dcisBaseUrl, utmBaseUrl } from "../helpers/constants";

export const getalldrones = ({ queryKey }) => {
  // console.log(queryKey[1], "token");
  return axios.get(`${utmBaseUrl}/v1/api/utm/drone/${queryKey[2]}`, {
    headers: { "x-access-token": queryKey[1] },
  });
};

export const addDrone = ({ token, fd }) => {
  return axios.post(`${utmBaseUrl}/v1/api/utm/drone`, fd, {
    headers: {
      "x-access-token": token,
      "Content-Type": "multipart/form-data",
      "Accept": "*/*"
    },
    // transformRequest: payload => payload,
  });
};

// TODO add token
export const getZones = ({ queryKey }) => {
  return axios.get(`${utmBaseUrl}/v1/api/zones/`, {
    headers: { "x-access-token": queryKey[1] },
  });
};

export const getWeatherData = ({ token, data }) => {
  return axios.post(`${utmBaseUrl}/v1/api/zones/weather`, data, {
    headers: { "x-access-token": token }
  })
}

export const getDroneDetails = ({ queryKey }) => {
  const token = queryKey[1];
  const droneId = queryKey[2]
  return axios.get(`${utmBaseUrl}/v1/api/utm/drone/drone-details/${droneId}`, {
    headers: { "x-access-token": token },
  });
}

export const getAirspaceDroneDetails = ({ queryKey }) => {
  const token = queryKey[1];
  const droneId = queryKey[2]
  return axios.get(`${utmBaseUrl}/v1/api/utm/drone/airspace/drone-details/${droneId}`, {
    headers: { "x-access-token": token },
  });
}

export const assignDroneUser = ({ token, data }) => {
  return axios.post(`${utmBaseUrl}/v1/api/user-drone`, data, {
    headers: { "x-access-token": token },
  });
}

export const unAssignedDroneApi = ({ token, data }) => {
  return axios.patch(`${utmBaseUrl}/v1/api/user-drone`, data, {
    headers: { "x-access-token": token },
  });
}

export const getAssignedDrones = (token, userId) => {
  return axios.get(`${utmBaseUrl}/v1/api/user-drone/${userId}`, {
    headers: { "x-access-token": token },
  });
}

export const updateDroneLocation = ({ token, droneId }) => {
  return axios.post(`${dcisBaseUrl}/v1/api/drones/firebase/${droneId}`, {}, {
    headers: { "x-access-token": token },
  })
}